"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CURRENCY = exports.CURRENCY_CODE = void 0;
const CURRENCY_CODE = exports.CURRENCY_CODE = {
  EUR: '€ - Euro',
  USD: '$ - U.S. Dollar',
  GBP: '£ - British Pound',
  SEK: 'SEK - Swedish Krona',
  NOK: 'NOK - Norwegian Krone',
  DKK: 'DKK - Danish Krone',
  AED: 'AED - United Arab Emirates Dirham',
  CHF: 'CHF - Swiss Franc'
};
const DEFAULT_CURRENCY = exports.DEFAULT_CURRENCY = 'EUR';